var map = {
	"./clipboard.png": "d78b",
	"./customize.png": "685d",
	"./gather-2.png": "518a",
	"./gather.png": "9584",
	"./globe.png": "7e09",
	"./hourglass.png": "d0ec",
	"./prediction.png": "c684",
	"./presentation.png": "0585"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "12c7";